import NiceModal from '@ebay/nice-modal-react';

import { useTranslation } from 'react-i18next';

import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalTitle } from 'components/global/styled/Modal.styled';

import OTOLinkStatuses from './OTOLinkStatuses';

const OTOLinkStatusesModal = NiceModal.create(({ sessionId }) => {
	const { t } = useTranslation();
	return (
		<Modal maxWidth="x-large" fullwidth>
			<ModalTitle>
				<Typography variant="p1">
					{t('otoLinkSession')} (<strong>{sessionId}</strong>)
				</Typography>
			</ModalTitle>
			<OTOLinkStatuses sessionId={sessionId} />
		</Modal>
	);
});

export default OTOLinkStatusesModal;
